/**
* 配置文件
*/
const CNF = {
    'sealApi': process.env.REACT_APP_SEAL_API,
    'plmsApi': process.env.REACT_APP_PLMS_API,
    'scmsApi': process.env.REACT_APP_SCMS_API,
    'ossApi': process.env.REACT_APP_OSS_API,
    'locale': 'zhCN',                             // antd国际化语言
    'projectCode': 'HOME',
    'projectName': '新致腾控制台',
    'projectFullname': '新致腾控制台',              // 项目全称
    'version': '1.0.0',
    'homeUrl': process.env.REACT_APP_HOME_URL,
    'loginUrl': process.env.REACT_APP_LOGIN_URL,  // 登录地址
    'userUrl': process.env.REACT_APP_USER_URL,    // 设置地址
    'bassicColor': '#001529',                     // 基础颜色
    'themeColors': [    //可选主题颜色
        '#fa541c',
        '#1677ff',
        '#13c2c2',
        '#722ed1',
        '#fa8c16',
        '#f5222d',
        '#52c41a',
        '#eb2f96',
        '#a0d911',
        '#faad14',
    ],
    'swatches': {   // 色板
        'default': ['#1983FF', '#07C9CA', '#F0884D', '#D580FF', '#7963FF', '#BD8F25', '#60C42E', '#FF80CA', '#2492B3', '#18C86F'],
    },
    'currentSwatche': 'default', // 当前色板
    'headerAuthKey': 'x-auth',
    'cookies': {
        'keySecure': true,
        'keyPath': '/',
        'keyDomain': process.env.REACT_APP_COOKIE_DOMAIN,
        'keyExpire': 86400,
        'keyUid': 'login_xzt_uid',
        'keyId': 'login_xzt_id',
        'keyToken': 'login_xzt_token',
        'keyUsername': 'login_xzt_username',
        'keyDisplayname': 'login_xzt_displayname',
        'keyAvatarUrl': 'login_xzt_avatar_url',
        'keyIsDisplayTableBorder': 'login_xzt_is_display_table_border',
    },
    'timeout': 5000,
    'tDivisor': 9999999999,
    'maxAge': 3600,
    'fontSize': 14,                          // 字体大小
    'menuHeight': '44px',
    'menuLineHeight': '40px',
    'messageDuration': 1.5,                  // 消息弹框持续时间，单位秒
    'animateDuration': 2000,                 // 动画持续时间，单位秒
    'screenWidth': 1440,                     // 系统屏幕宽度
    'searchMarginLeft': 5,                   // 搜索栏左边距
    'rowMarginTop': 10,                      // 行距顶部高度
    'lineHeight': 2.2,                       // 行高
    'tableOperationColumnWidth': 80,         // 表格操作者列宽度
    'tableStatusColumnWidth': 80,            // 表格状态列宽度
    'tableCreateTimeColumnWidth': 120,       // 表格创建时间列宽度
    'tableCreateDisplayeColumnWidth': 90,    // 表格创建者列宽度
    'pageSize': 10,
    'DPL': 2,                                // 小数点长度（Decimal Point Length）
    'status': [
        { 'key': '激活', 'value': '激活' },
        { 'key': '禁用', 'value': '禁用' },
    ],
    'woLevels': [
        { 'key': '1级工单', 'value': 1 },
        { 'key': '2级工单', 'value': 2 },
        { 'key': '3级工单', 'value': 3 },
        { 'key': '4级工单', 'value': 4 }
    ],
    'woTypes': [
        { 'key': '硬件', 'value': 1 },
        { 'key': '软件', 'value': 2 },
        { 'key': '网络', 'value': 3 },
        { 'key': '需求', 'value': 4 },
        { 'key': '人工', 'value': 5 },
        { 'key': '其它', 'value': 6 }
    ],
}

export default CNF;